import script from "./practice-assistant-list.vue?vue&type=script&setup=true&lang=js"
export * from "./practice-assistant-list.vue?vue&type=script&setup=true&lang=js"

import "./practice-assistant-list.vue?vue&type=style&index=0&id=6ae785b9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae785b9"]])

export default __exports__